module.exports = __webpack_public_path__ + "static/media/decorative_header.cec49c06.svg";